export default __webpack_public_path__ + "static/media/ic-generate.bcc974e2.svg";